import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxLoadingModule } from 'ngx-loading';
import { AlphaNumericOnlyDirective } from '../directives/alpha-numeric-only.directive';
import { AlphaNumericOnlyWithHypenDirective } from '../directives/alpha-numeric-with-hypen.directive';
import { AlphaOnlyDirective } from '../directives/alpha-only.directive';
import { NoAutocompleteDirective } from '../directives/auto-complete.directive';
import { NumbersOnlyDirective } from '../directives/numbers-only.directive';
import { NumberHyphenOnlyDirective } from '../directives/numeric-hyphen.directive';
import { MaterialDialogComponent } from '../matdialog/matdialog.component';
import { MapToIterable } from '../pipes/keys';
import { SortPipe } from '../pipes/sort';
import { TooltipListPipe } from '../pipes/tooltip-list';
import { MaterialModule } from './material.module';

@NgModule({
  imports: [CommonModule, FormsModule, ReactiveFormsModule, MaterialModule, NgxLoadingModule.forRoot({})],
  declarations: [
    MaterialDialogComponent,
    NoAutocompleteDirective,
    MapToIterable,
    TooltipListPipe,
    SortPipe,
    AlphaOnlyDirective,
    AlphaNumericOnlyDirective,
    AlphaNumericOnlyWithHypenDirective,
    NumberHyphenOnlyDirective,
    NumbersOnlyDirective
  ],
  exports: [
    MaterialDialogComponent,
    NoAutocompleteDirective,
    MapToIterable,
    TooltipListPipe,
    SortPipe,
    AlphaOnlyDirective,
    AlphaNumericOnlyDirective,
    NumberHyphenOnlyDirective,
    NumbersOnlyDirective,
    AlphaNumericOnlyWithHypenDirective,
    MaterialModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    NgxLoadingModule,
  ],
  entryComponents: [MaterialDialogComponent],
})
export class SharedModule {}
